// Minimal classnames helper. Joins truthy class fragments; ignores false/null/
// undefined. Keeps component JSX readable without a classnames dependency.
//   cx('card', isOpen && 'is-open', tone && `t-${tone}`)
export const cx = (...parts) => parts.filter(Boolean).join(' ');

export default cx;
